<template>
  <subscription-list :client-id="$route.params.id"></subscription-list>
</template>
<script>
  import SubscriptionList from 'src/views/admin/e-commerce/subscriptions/SubscriptionList'

  export default {
    name: 'client-management-subscriptions',
    components: {
      SubscriptionList,
    },
  }
</script>
<style>
</style>
